import { trackEvent } from '@brighterly/lib-core-functions/analytics'

import type { RouteLocationNormalizedGeneric } from '#vue-router'

let tracked = false

const toId = (raw: string): string => raw.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')

/**
 * One Notification_click per page load, when the URL came from a backend notification link: the app never sets
 * `notify_channel` itself, while in-app hops set only `notify_type` and are navigation, not notifications.
 */
export const trackNotificationLanding = (route: RouteLocationNormalizedGeneric): void => {
  const channel = route.query.notify_channel
  if (tracked || typeof channel !== 'string' || !channel) return
  tracked = true

  const type = route.query.notify_type
  trackEvent('Notification_click', {
    feature: 'navigation',
    name: toId(String(route.name ?? 'unknown')),
    ...(typeof type === 'string' && type ? { notification_type: type } : {}),
    channel,
  })
}
